/* DelaFuente — Diamond Picker (desktop MODAL experience)
 * Phase 1: sample data, modal UX + "Your diamond" card + engraving.
 * Hand-pick add-to-cart is intentionally gated (Phase 2 = real Nivoda stones + Cart Transform bundle).
 * Styling inherits the Heritage design system via CSS custom properties (see dlf-diamond-picker.css).
 * Ported from the desktop prototype (DelaFuente Product Desktop.dc.html renderVals()).
 * rev: 2026-07-26 hint-link-locale
 */
(function () {
  'use strict';

  var ROOT_ID = 'dlf-dp-root';
  var cfgEl = document.getElementById('dlf-dp-config');
  if (!cfgEl) return;
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { CFG = {}; }

  /* ---- i18n: strings + date locale. English path is unchanged; ES pulled from CFG.lang. ---- */
  var ES = String(CFG.lang || '').slice(0, 2).toLowerCase() === 'es';
  var LOC = ES ? 'es-MX' : 'en-US';
  var L = ES ? {
    loading: 'Cargando diamantes…', loadErr: 'No se pudo cargar el inventario.', tryAgain: 'Reintentar',
    noMatch: 'Ningún diamante coincide con estos filtros.', clearFilters: 'Limpiar todos los filtros',
    matchOne: 'diamante coincide con tu selección', matchMany: 'diamantes coinciden con tu selección',
    clearAll: 'Limpiar todo', sort: 'Orden', priceUp: 'Precio ↑', priceDown: 'Precio ↓',
    caratWeight: 'Peso en quilates', shape: 'Forma', brilliant: 'brillante', color: 'Color', clarity: 'Claridad',
    cut: 'Corte', polish: 'Pulido', symmetry: 'Simetría', fluorescence: 'Fluorescencia', measurements: 'Medidas',
    table: 'Mesa', depth: 'Profundidad', lwRatio: 'Relación L/A',
    backAll: 'Volver a todos los diamantes', allN1: 'Todos los ', allN2: ' diamantes',
    photo: 'Foto', spin360: 'Giro 360°', certificate: 'CERTIFICADO', view: 'Ver →',
    colorWord: 'color', cutWord: 'corte',
    footnote1: 'Precio final del anillo completo con este diamante — incluye tu montura ', footnote2: ' en el metal que elijas.',
    chooseThis: 'Elegir este diamante · Total del anillo ',
    chooseForPre: 'Elige tu diamante para ', chooseShapePre: 'Elige tu diamante ', chooseShapeSuf: '',
    yourEngraving: 'Tu grabado',
    engFine: 'Grabado a mano dentro del aro, hasta 16 caracteres. Las piezas grabadas son venta final.',
    addEngraving: 'Agrega un grabado', engTag: 'OPCIONAL · SIN COSTO', engPlaceholder: 'p. ej. Por siempre · 18.4.26',
    yourDiamond: 'Tu diamante', changeDiamond: 'Cambiar diamante', remove: 'Quitar',
    preferOwn: '¿Prefieres elegir el tuyo?', handpick: 'Elige tu diamante a mano →',
    getItBy: 'Llega para el ', madeToOrder: 'Hecho por encargo. ',
    totalMTO: 'Total con tu diamante · Hecho por encargo, ', totalMid: 'Total con tu diamante · ', totalBrief: 'Total con tu diamante',
    addExpress: 'Agrega elaboración exprés', by: 'Para el ', expressCrafting: 'Elaboración exprés',
    sizingLater: 'Confirmar tras la entrega — kit de medición gratis incluido', helpLater: 'Ayúdame después',
    sizingNote: 'Con tu anillo llega un kit de medición gratis — confirma tu talla cuando llegue. Compra hoy.',
    sizeGuideQ: '¿No estás segura de tu talla?', sizeGuideLink: 'Pide un kit de medición gratis →',
    cartErr: 'No se pudo agregar al carrito.', pickSize: 'Elige la talla del anillo primero.',
    stoneSoon: 'Selección de piedra real disponible pronto.', netErr: 'Error de red al agregar al carrito.',
    styleScript: 'Cursiva', styleSerif: 'Serif', styleBlock: 'Bloque',
    centerSuffix: ' al centro'
  } : {
    loading: 'Loading diamonds…', loadErr: 'Couldn’t load the inventory.', tryAgain: 'Try again',
    noMatch: 'No diamonds match these filters.', clearFilters: 'Clear all filters',
    matchOne: 'diamond matches your selection', matchMany: 'diamonds match your selection',
    clearAll: 'Clear all', sort: 'Sort', priceUp: 'Price ↑', priceDown: 'Price ↓',
    caratWeight: 'Carat weight', shape: 'Shape', brilliant: 'brilliant', color: 'Color', clarity: 'Clarity',
    cut: 'Cut', polish: 'Polish', symmetry: 'Symmetry', fluorescence: 'Fluorescence', measurements: 'Measurements',
    table: 'Table', depth: 'Depth', lwRatio: 'L/W ratio',
    backAll: 'Back to all diamonds', allN1: 'All ', allN2: ' diamonds',
    photo: 'Photo', spin360: '360° spin', certificate: 'CERTIFICATE', view: 'View →',
    colorWord: 'color', cutWord: 'cut',
    footnote1: 'Final price for the complete ring with this diamond — includes your ', footnote2: ' setting in your chosen metal.',
    chooseThis: 'Choose this diamond · Ring total ',
    chooseForPre: 'Choose your diamond for ', chooseShapePre: 'Choose your ', chooseShapeSuf: ' diamond',
    yourEngraving: 'Your engraving',
    engFine: 'Hand-engraved inside the band, up to 16 characters. Engraved pieces are final sale.',
    addEngraving: 'Add an engraving', engTag: 'OPTIONAL · COMPLIMENTARY', engPlaceholder: 'e.g. Forever · 4.18.26',
    yourDiamond: 'Your diamond', changeDiamond: 'Change diamond', remove: 'Remove',
    preferOwn: 'Prefer to choose your own?', handpick: 'Hand-pick your diamond →',
    getItBy: 'Get it by ', madeToOrder: 'Made to order. ',
    totalMTO: 'Total with your diamond · Made to order, ', totalMid: 'Total with your diamond · ', totalBrief: 'Total with your diamond',
    addExpress: 'Add express crafting', by: 'By ', expressCrafting: 'Express crafting',
    sizingLater: 'Confirm after delivery — free sizing kit included', helpLater: 'Help me later',
    sizingNote: 'A free sizing kit ships with your ring — confirm your size once it arrives. Check out today.',
    sizeGuideQ: 'Not sure about your size?', sizeGuideLink: 'Get a free sizing kit →',
    cartErr: 'Couldn’t add to cart.', pickSize: 'Pick your ring size first.',
    stoneSoon: 'Real stone selection coming soon.', netErr: 'Network error adding to cart.',
    styleScript: 'Script', styleSerif: 'Serif', styleBlock: 'Block',
    centerSuffix: ' center'
  };
  function colorPhrase(c){ return ES ? (L.colorWord + ' ' + c) : (c + ' ' + L.colorWord); }
  function cutPhrase(cut){ return ES ? (L.cutWord + ' ' + cut) : (cut + ' ' + L.cutWord); }
  // Shopify option VALUES stay in English (the CSV import doesn't apply them, and code keys off
  // them — e.g. the CSS that hides the "Hand-picked" pill). Translate at display points only,
  // mirroring the _ov_en/_ov_es map in snippets/variant-main-picker.liquid.
  var OV_ES = { '14K Yellow Gold':'Oro amarillo 14K', '14K White Gold':'Oro blanco 14K', '14K Rose Gold':'Oro rosa 14K',
    '18K Yellow Gold':'Oro amarillo 18K', '18K White Gold':'Oro blanco 18K', '18K Rose Gold':'Oro rosa 18K',
    'Platinum':'Platino', 'Hand-picked':'Seleccionado a mano' };
  function ovDisp(v){ return (ES && v && OV_ES[v]) || v; }

  var SETTING_BASE = (CFG.settingBase != null && !isNaN(parseFloat(CFG.settingBase))) ? parseFloat(CFG.settingBase) : 1450;
  // Detail opens straight into the auto-spinning 360; the photo is the fallback (toggle "Photo").
  // Flip to false for photo-first (tap "360° spin" to load) if loupe360 misses become annoying.
  var AUTO_360 = CFG.auto360 !== false;
  var PRODUCT_TITLE = CFG.productTitle || 'The Arco | East West Oval Solitaire';
  var SETTING_LABEL = PRODUCT_TITLE.split('|')[0].trim();
  // Delivery (Standard vs Express make). Weeks/fee/variant are configurable metafields.
  var STD_WEEKS = parseInt(CFG.standardWeeks, 10) || 5;
  var EXPRESS_WEEKS = parseInt(CFG.expressWeeks, 10) || 3;
  var EXPRESS_FEE = (CFG.expressFee != null && !isNaN(parseFloat(CFG.expressFee))) ? parseFloat(CFG.expressFee) : 180;
  var EXPRESS_VARIANT = CFG.expressVariantId || '';
  function shipDateStr(weeks){ var d = new Date(); d.setDate(d.getDate() + weeks * 7); return d.toLocaleDateString(LOC, { month: 'long', day: 'numeric' }); }
  function shipDateShort(weeks){ var d = new Date(); d.setDate(d.getDate() + weeks * 7); return d.toLocaleDateString(LOC, { month: 'short', day: 'numeric' }); }
  function priceNum(txt){ var m = String(txt || '').replace(/,/g, '').match(/([\d]+(?:\.[\d]+)?)/); return m ? parseFloat(m[1]) : 0; }
  function feeStr(){ return fmt(EXPRESS_FEE).replace(/\.00$/, ''); }
  function deliveryFee(){ return state.delivery === 'express' ? EXPRESS_FEE : 0; }

  /* ---- Sample fallback. Real data comes from window.__DLF_DIAMONDS (assets/dlf-diamonds.js). ---- */
  var SAMPLE = [
    {id:1,ct:'1.01',color:'D',clar:'VVS1',cut:'Excellent',lab:'GIA',dims:'7.21 × 5.18 × 3.16',price:1980,polish:'Excellent',sym:'Excellent',table:57,depth:62.4,fluor:'None',cert:'2185749301'},
    {id:2,ct:'1.18',color:'E',clar:'VVS2',cut:'Ideal',lab:'IGI',dims:'7.84 × 5.55 × 3.39',price:2150,polish:'Excellent',sym:'Very Good',table:58,depth:61.8,fluor:'Faint',cert:'441907324'},
    {id:3,ct:'1.53',color:'F',clar:'VVS1',cut:'Excellent',lab:'GIA',dims:'8.62 × 5.91 × 3.66',price:2740,polish:'Excellent',sym:'Excellent',table:56,depth:62.9,fluor:'None',cert:'2295018744'},
    {id:4,ct:'1.71',color:'E',clar:'VVS2',cut:'Excellent',lab:'IGI',dims:'9.02 × 6.18 × 3.81',price:2980,polish:'Very Good',sym:'Excellent',table:59,depth:61.5,fluor:'None',cert:'502771188'},
    {id:5,ct:'2.04',color:'E',clar:'VVS2',cut:'Excellent',lab:'IGI',dims:'9.55 × 6.62 × 4.05',price:3180,polish:'Excellent',sym:'Very Good',table:57,depth:62.1,fluor:'Faint',cert:'514203996'},
    {id:6,ct:'2.01',color:'D',clar:'VVS1',cut:'Excellent',lab:'GIA',dims:'9.48 × 6.57 × 4.02',price:3525,polish:'Excellent',sym:'Excellent',table:56,depth:61.9,fluor:'None',cert:'2317660415'},
    {id:7,ct:'2.55',color:'F',clar:'VVS1',cut:'Ideal',lab:'GIA',dims:'10.31 × 7.12 × 4.38',price:4490,polish:'Excellent',sym:'Excellent',table:58,depth:62.6,fluor:'None',cert:'2330874512'},
    {id:8,ct:'2.78',color:'E',clar:'VVS2',cut:'Excellent',lab:'IGI',dims:'10.66 × 7.35 × 4.52',price:4980,polish:'Very Good',sym:'Excellent',table:59,depth:61.4,fluor:'Faint',cert:'558119003'},
    {id:9,ct:'3.06',color:'D',clar:'VVS1',cut:'Excellent',lab:'GIA',dims:'11.04 × 7.61 × 4.69',price:6240,polish:'Excellent',sym:'Excellent',table:57,depth:62.0,fluor:'None',cert:'2360551879'},
    {id:10,ct:'3.42',color:'F',clar:'VVS2',cut:'Ideal',lab:'IGI',dims:'11.52 × 7.94 × 4.88',price:6890,polish:'Excellent',sym:'Very Good',table:58,depth:61.7,fluor:'None',cert:'573998241'},
    {id:11,ct:'4.00',color:'D',clar:'VVS1',cut:'Excellent',lab:'GIA',dims:'12.18 × 8.39 × 5.16',price:9200,polish:'Excellent',sym:'Excellent',table:56,depth:62.3,fluor:'None',cert:'2388104567'}
  ];

  function mapCode(v){ var m={EX:'Excellent',ID:'Ideal',VG:'Very Good',GD:'Good',G:'Good',F:'Fair',PR:'Poor'}; return v ? (m[v] || v) : v; }
  // URL sink guard: video (iframe src), certPdf (href) and img all end up in the DOM. Accept only
  // http(s) so a forged value (e.g. via ?dlf_hint) can't inject a javascript:/data: URL.
  function safeUrl(u){ var s = (u == null ? '' : String(u)).trim(); return /^https?:\/\//i.test(s) ? s : ''; }
  function normReal(d){
    return { id:d.variantId, variantId:d.variantId, productId:d.productId, handle:d.handle,
      ct:String(d.carat), color:d.color, clar:d.clarity, cut:mapCode(d.cut), lab:d.lab, shape:d.shape,
      polish:mapCode(d.polish), sym:mapCode(d.symmetry),
      dims:String(d.measurements||'').replace(/\s*mm\s*$/i,'').replace(/\s*[x×]\s*/gi,' × ').trim(),
      price:Number(d.price), cert:d.cert, certPdf:safeUrl(d.certPdf), video:safeUrl(d.video), img:safeUrl(d.img) };
  }
  var DIAMONDS = (window.__DLF_DIAMONDS && window.__DLF_DIAMONDS.length) ? window.__DLF_DIAMONDS.map(normReal) : SAMPLE;
  /* Server mode: when a Storefront token is configured, the catalog is fetched on demand
   * (server-filtered, cursor-paginated) instead of shipping the whole array to the browser.
   * Falls back to the static DIAMONDS array when disabled, so dev/preview keeps working. */
  var SERVER = !!(window.DLF_DIAMOND_API && window.DLF_DIAMOND_API.enabled);
  var LOADED = {}; // id -> item, accumulates every fetched stone so detail/cart can resolve the chosen one
  var SHAPE = CFG.diamondShape || (DIAMONDS[0] && DIAMONDS[0].shape) || 'Oval';
  function mediaInner(d, big){ return d && d.img ? '<img class="dlf-photo' + (big ? ' dlf-photo--lg' : '') + '" src="' + esc(d.img) + '" alt="" loading="lazy">' : '<div class="dlf-stone' + (big ? ' dlf-stone--lg' : '') + '"></div>'; }

  // key = stable state/data key (never localized); label = localized chip display.
  var FILTER_DEFS = [
    {key:'Carat', label: ES ? 'Quilates' : 'Carat', type:'range', options:[
      {label:'1.0 – 1.5 ct', min:1.0, max:1.4999},
      {label:'1.5 – 2.0 ct', min:1.5, max:1.9999},
      {label:'2.0 – 3.0 ct', min:2.0, max:2.9999},
      {label:'3.0 ct +', min:3.0, max:99}
    ]},
    {key:'Color', label:'Color', field:'color', options:['D','E','F']},
    {key:'Cut', label: ES ? 'Corte' : 'Cut', field:'cut', options:['Ideal','Excellent']},
    {key:'Lab', label:'Lab', field:'lab', options:['GIA','IGI']},
    {key:'Clarity', label: ES ? 'Claridad' : 'Clarity', field:'clar', options:['VVS1','VVS2']}
  ];
  // Fancy shapes (oval, etc.) don't receive a cut grade — drop the Cut filter for them.
  if (SHAPE !== 'Round') FILTER_DEFS = FILTER_DEFS.filter(function(d){ return d.key !== 'Cut'; });

  var ENG_STYLES = [{key:'script',label:L.styleScript},{key:'serif',label:L.styleSerif},{key:'block',label:L.styleBlock}];

  var state = {
    open: false, detailId: null, chosenId: null,
    filterSel: { Carat:[], Color:[], Cut:[], Lab:[], Clarity:[] },
    openFilter: null, sort: 'asc',
    engOpen: false, engText: '', engStyle: 'script',
    delivery: 'standard', // 'standard' | 'express' (express adds a make-time fee)
    helpLater: false, // defer ring sizing (free kit ships with the order)
    show360: false, // detail 360 viewer only loads on tap (photo is the safe default)
    bdOpen: false, // price-breakdown expander on the "Your diamond" card
    headHidden: false, // collapse the title bar on scroll-down to show more diamonds
    // server-mode paging
    srvItems: [], srvCursor: null, srvHasNext: false, srvLoading: false, srvLoaded: false, srvErr: null
  };

  // CUR = the market currency code (MXN/EUR/USD…), discovered from the Storefront API in server
  // mode so the roll-up matches the market prices. Null until known -> plain USD-style fallback.
  var CUR = null;
  function fmt(n){
    if (CUR){ try {
      var s = Number(n).toLocaleString(LOC, { style:'currency', currency:CUR });
      // The peso uses the "$" glyph too; append the code so it can't be read as USD (matches the
      // theme's "$… MXN"). Unambiguous symbols (€, USD's own $) are left as-is.
      if (CUR !== 'USD' && s.indexOf('$') > -1 && s.indexOf(CUR) === -1) s += ' ' + CUR;
      return s;
    } catch(e){} }
    return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function diamondById(id){ if (LOADED[id]) return LOADED[id]; if (SERVER){ return null; } for (var i=0;i<DIAMONDS.length;i++){ if (DIAMONDS[i].id === id) return DIAMONDS[i]; } return null; }

  function passes(d){
    return FILTER_DEFS.every(function(def){
      var sel = state.filterSel[def.key] || [];
      if (sel.length === 0) return true;
      if (def.type === 'range'){
        var c = parseFloat(d.ct);
        return def.options.some(function(o){ return sel.indexOf(o.label) >= 0 && c >= o.min && c <= o.max; });
      }
      return sel.indexOf(d[def.field]) >= 0;
    });
  }
  function filtered(){
    if (SERVER){ return state.srvItems.slice(); } // already server-filtered + sorted
    var list = DIAMONDS.filter(passes).slice();
    list.sort(function(a,b){ return state.sort === 'asc' ? a.price - b.price : b.price - a.price; });
    return list;
  }

  /* ---------- server-mode fetching ---------- */
  var _reloadTimer = null;
  function cacheItems(items){ for (var i=0;i<items.length;i++){ if (items[i].id != null) LOADED[items[i].id] = items[i]; } }
  function reloadServer(){
    if (!SERVER) return;
    state.srvLoading = true; state.srvErr = null; state.srvLoaded = false; state.headHidden = false;
    state.srvItems = []; state.srvCursor = null; state.srvHasNext = false;
    var reqSort = state.sort, reqSel = JSON.stringify(state.filterSel);
    renderModal();
    window.DLF_DIAMOND_API.query({ filterSel: state.filterSel, sort: state.sort }).then(function(res){
      // ignore stale responses if filters/sort changed while in flight
      if (reqSort !== state.sort || reqSel !== JSON.stringify(state.filterSel)) return;
      cacheItems(res.items);
      state.srvItems = res.items; state.srvCursor = res.pageInfo.endCursor;
      state.srvHasNext = res.pageInfo.hasNextPage; state.srvLoading = false; state.srvLoaded = true;
      renderModal();
    }).catch(function(err){
      state.srvLoading = false; state.srvLoaded = true; state.srvErr = (err && err.message) || 'Error';
      renderModal();
    });
  }
  function reloadServerDebounced(){ if (_reloadTimer) clearTimeout(_reloadTimer); _reloadTimer = setTimeout(reloadServer, 220); }
  function scrollEl(){ var r = document.getElementById(ROOT_ID); return r ? r.querySelector('.dlf-scroll') : null; }
  function loadMoreServer(){
    if (!SERVER || state.srvLoading || !state.srvHasNext) return;
    var keepTop = (function(){ var s = scrollEl(); return s ? s.scrollTop : 0; })();
    state.srvLoading = true; renderModal(); (function(){ var s = scrollEl(); if (s) s.scrollTop = keepTop; })();
    var reqSort = state.sort, reqSel = JSON.stringify(state.filterSel);
    window.DLF_DIAMOND_API.query({ filterSel: state.filterSel, sort: state.sort, after: state.srvCursor }).then(function(res){
      if (reqSort !== state.sort || reqSel !== JSON.stringify(state.filterSel)) return;
      cacheItems(res.items);
      state.srvItems = state.srvItems.concat(res.items);
      state.srvCursor = res.pageInfo.endCursor; state.srvHasNext = res.pageInfo.hasNextPage;
      state.srvLoading = false; renderModal();
      var s = scrollEl(); if (s) s.scrollTop = keepTop; // keep position — new cards appended below
    }).catch(function(err){ state.srvLoading = false; state.srvErr = (err && err.message) || 'Error'; renderModal(); });
  }
  /* Infinite scroll: auto-load the next page as the grid nears the bottom (re-armed each render
   * since the panel is rebuilt). Also loads when the first page is too short to scroll. */
  function applyHeadState(panel){
    var lt = (panel || document.getElementById(ROOT_ID)).querySelector('.dlf-listtop');
    if (lt){ if (state.headHidden) lt.classList.add('is-up'); else lt.classList.remove('is-up'); }
  }
  function attachInfiniteScroll(panel){
    if (!SERVER || state.detailId) return;
    var sc = panel.querySelector('.dlf-scroll');
    if (!sc) return;
    var listtop = sc.querySelector('.dlf-listtop');
    var lastTop = sc.scrollTop;
    sc.addEventListener('scroll', function(){
      var t = sc.scrollTop;
      // sticky header reveals on scroll-up / at top, hides on scroll-down — so you can filter
      // without scrolling all the way to the top.
      if (listtop){
        if (t <= 4){ state.headHidden = false; listtop.classList.remove('is-up'); }
        else if (t > lastTop + 5 && t > 70){ state.headHidden = true; listtop.classList.add('is-up'); }
        else if (t < lastTop - 5){ state.headHidden = false; listtop.classList.remove('is-up'); }
      }
      lastTop = t;
      if (!state.detailId && state.srvHasNext && !state.srvLoading && t + sc.clientHeight >= sc.scrollHeight - 280) loadMoreServer();
    }, { passive: true });
    if (state.srvHasNext && !state.srvLoading && sc.scrollHeight <= sc.clientHeight + 40) loadMoreServer();
  }

  /* ---------- modal rendering ---------- */
  function chipHTML(def){
    var sel = state.filterSel[def.key] || [];
    var active = sel.length > 0;
    var valTxt = sel.length <= 2 ? sel.join(', ') : (sel.slice(0,2).join(', ') + ' +' + (sel.length - 2));
    var display = active ? (def.label + ': ' + valTxt) : def.label;
    var labels = def.type === 'range' ? def.options.map(function(o){ return o.label; }) : def.options;
    var opts = labels.map(function(lbl){
      var checked = sel.indexOf(lbl) >= 0;
      return '<div class="dlf-opt" data-action="opt:' + esc(def.key) + ':' + esc(lbl) + '">' +
        '<span class="dlf-check' + (checked ? ' is-on' : '') + '">' + (checked ? '✓' : '') + '</span>' + esc(lbl) + '</div>';
    }).join('');
    var pop = state.openFilter === def.key ? '<div class="dlf-pop">' + opts + '</div>' : '';
    return '<div class="dlf-chipwrap">' +
      '<div class="dlf-chip' + (active ? ' is-active' : '') + '" data-action="chip:' + esc(def.key) + '">' + esc(display) + '<span class="dlf-caret">▾</span></div>' +
      pop + '</div>';
  }
  function cardHTML(d){
    var cutShort = d.cut === 'Excellent' ? 'EX' : (d.cut === 'Ideal' ? 'ID' : d.cut);
    var specTxt = [d.color, d.clar, d.cut].filter(Boolean).join(' · ');
    return '<div class="dlf-card" data-action="open:' + d.id + '">' +
      '<div class="dlf-card__media">' + mediaInner(d) +
        '<div class="dlf-badges"><span class="dlf-badge">' + esc(d.lab) + '</span>' + (cutShort ? '<span class="dlf-badge dlf-badge--dark">' + esc(cutShort) + '</span>' : '') + '</div>' +
        (d.video ? '<span class="dlf-360">360° · video</span>' : '') + '</div>' +
      '<div class="dlf-card__body">' +
        '<div class="dlf-card__title">' + esc(d.ct) + ' ct ' + esc(SHAPE) + '</div>' +
        '<div class="dlf-card__spec">' + esc(specTxt) + '</div>' +
        '<div class="dlf-card__dim">' + esc(d.dims) + ' mm</div>' +
        '<div class="dlf-card__price"><span>' + fmt(SETTING_BASE + d.price) + '</span></div>' +
      '</div></div>';
  }
  function listHTML(){
    var list = filtered();
    var anyActive = FILTER_DEFS.some(function(def){ return (state.filterSel[def.key]||[]).length > 0; });
    var chips = FILTER_DEFS.map(chipHTML).join('');

    var cards;
    if (SERVER && state.srvLoading && !list.length){
      cards = '<div class="dlf-loading"><span class="dlf-spinner"></span>' + esc(L.loading) + '</div>';
    } else if (SERVER && state.srvErr && !list.length){
      cards = '<div class="dlf-empty">' + esc(L.loadErr) + '<br><span data-action="retry">' + esc(L.tryAgain) + '</span></div>';
    } else if (!list.length){
      cards = '<div class="dlf-empty">' + esc(L.noMatch) + '<br><span data-action="clear">' + esc(L.clearFilters) + '</span></div>';
    } else {
      cards = '<div class="dlf-grid">' + list.map(cardHTML).join('') + '</div>';
      if (SERVER && state.srvHasNext){
        cards += '<div class="dlf-more"><span class="dlf-spinner"></span></div>'; // infinite-scroll loader
      }
    }

    var _word = (list.length === 1 && !(SERVER && state.srvHasNext)) ? L.matchOne : L.matchMany;
    var countHTML;
    if (SERVER){
      countHTML = '<b>' + list.length + (state.srvHasNext ? '+' : '') + '</b> ' + esc(_word);
    } else {
      countHTML = '<b>' + list.length + '</b> ' + esc(_word);
    }
    var metaHTML = '<div class="dlf-meta"><div class="dlf-count">' + countHTML + '</div>' +
      '<div class="dlf-metaright">' + (anyActive ? '<span class="dlf-clear" data-action="clear">' + esc(L.clearAll) + '</span>' : '') +
      '<span class="dlf-sort" data-action="sort">' + esc(L.sort) + ': ' + (state.sort === 'asc' ? esc(L.priceUp) : esc(L.priceDown)) + '</span></div></div>';
    var backdrop = state.openFilter ? '<div class="dlf-filterbackdrop" data-action="closefilters"></div>' : '';
    return backdrop + '<div class="dlf-list">' +
      '<div class="dlf-x dlf-x--float" data-action="close">×</div>' +
      '<div class="dlf-scroll">' +
        '<div class="dlf-listtop">' + titleHTML() + '<div class="dlf-filters">' + chips + '</div>' + metaHTML + '</div>' +
        cards +
      '</div>' +
      '</div>';
  }
  function detailHTML(d){
    var parts = String(d.dims).split(/[x×]/);
    // dimL/dimW (NOT L/W) — L is the global i18n dict; a local L here would shadow it and blank the labels.
    var dimL = parseFloat(parts[0]), dimW = parseFloat(parts[1]);
    var ratio = (dimL && dimW) ? (dimL / dimW).toFixed(2) : null;
    var specs = [
      [L.caratWeight, d.ct + ' ct'], [L.shape, (d.shape || 'Oval') + ' ' + L.brilliant], [L.color, d.color], [L.clarity, d.clar],
      (d.cut ? [L.cut, d.cut] : null), (d.polish ? [L.polish, d.polish] : null), (d.sym ? [L.symmetry, d.sym] : null),
      (d.fluor != null ? [L.fluorescence, d.fluor] : null),
      [L.measurements, d.dims + ' mm'],
      (d.table != null ? [L.table, d.table + '%'] : null),
      (d.depth != null ? [L.depth, d.depth + '%'] : null),
      (ratio ? [L.lwRatio, ratio] : null)
    ].filter(Boolean).map(function(r){ return '<div class="dlf-specrow"><span>' + esc(r[0]) + '</span><span>' + esc(r[1]) + '</span></div>'; }).join('');
    return '<div class="dlf-detail"><div class="dlf-detail__scroll">' +
      '<div class="dlf-detail__left">' +
        '<div class="dlf-back" data-action="back"><span>←</span> ' + (SERVER ? esc(L.backAll) : esc(L.allN1 + DIAMONDS.length + L.allN2)) + '</div>' +
        '<div class="dlf-detail__media">' + ((state.show360 && d.video)
          ? '<iframe class="dlf-360iframe" data-video="' + esc(String(d.video)) + '" scrolling="no" allow="fullscreen" title="360° view"></iframe><button type="button" class="dlf-play360 dlf-play360--back" data-action="hide360"><span class="dlf-play360__ic">⤺</span> ' + esc(L.photo) + '</button>'
          : mediaInner(d, true) + (d.video ? '<button type="button" class="dlf-play360" data-action="play360"><span class="dlf-play360__ic">↻</span> ' + esc(L.spin360) + '</button>' : '')) + '</div>' +
        '<div class="dlf-cert"><div><div class="dlf-cert__eyebrow">' + esc(L.certificate) + '</div><div class="dlf-cert__val">' + esc(d.lab + ' · ' + d.cert) + '</div></div>' + (d.certPdf ? '<a class="dlf-cert__link" href="' + esc(d.certPdf) + '" target="_blank" rel="noopener">' + esc(L.view) + '</a>' : '<span class="dlf-cert__link">' + esc(L.view) + '</span>') + '</div>' +
      '</div>' +
      '<div class="dlf-detail__right"><div class="dlf-detail__head">' +
        '<div><div class="dlf-detail__title">' + esc(d.ct) + ' ct ' + esc(SHAPE) + '</div><div class="dlf-detail__sub">' + esc([colorPhrase(d.color), d.clar, (d.cut ? cutPhrase(d.cut) : '')].filter(Boolean).join(' · ')) + '</div></div>' +
        '<div class="dlf-detail__price">' + fmt(SETTING_BASE + d.price) + '</div></div>' +
        '<div class="dlf-specs">' + specs + '</div></div>' +
      '</div>' +
      '<div class="dlf-detail__foot"><div class="dlf-detail__footnote">' + esc(L.footnote1) + esc(SETTING_LABEL) + esc(L.footnote2) + '</div>' +
        '<div class="dlf-choose" data-action="choose:' + d.id + '">' + esc(L.chooseThis) + fmt(SETTING_BASE + d.price) + '</div></div></div>';
  }
  function titleHTML(){
    return '<div class="dlf-modal__title"><span class="dlf-t-lg">' + esc(L.chooseForPre) + esc(PRODUCT_TITLE) + '</span><span class="dlf-t-sm">' + esc(L.chooseShapePre + String(SHAPE).toLowerCase() + L.chooseShapeSuf) + '</span></div>';
  }
  function panelBodyHTML(){
    var det = state.detailId ? diamondById(state.detailId) : null;
    // Detail keeps a fixed header; the list's header lives inside the scroller so it slides
    // away naturally as you scroll down (and back as you scroll up) — no janky collapse.
    if (det){
      return '<div class="dlf-modal__head">' + titleHTML() + '<div class="dlf-x" data-action="close">×</div></div>' + detailHTML(det);
    }
    return listHTML();
  }
  function ensureModal(){
    var root = document.getElementById(ROOT_ID);
    if (!root){ root = document.createElement('div'); root.id = ROOT_ID; document.body.appendChild(root); }
    return root;
  }
  function stickyBar(){ return document.querySelector('sticky-add-to-cart, .sticky-add-to-cart'); }
  // Mark the div-based controls as real buttons for assistive tech + keyboard. Centralized here so
  // every re-render keeps them operable without touching each render template. 'stop' is the panel
  // wrapper (not a control), so it's skipped.
  function a11yControls(panel){
    var els = panel.querySelectorAll('[data-action]');
    for (var i = 0; i < els.length; i++){
      var el = els[i];
      if ((el.getAttribute('data-action') || '').split(':')[0] === 'stop') continue;
      if (el.getAttribute('role') !== 'button') el.setAttribute('role', 'button');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    }
  }
  function focusablesIn(panel){
    return Array.prototype.slice.call(panel.querySelectorAll(
      '[data-action]:not([data-action^="stop"]), a[href], input, select, textarea, button, [tabindex="0"]'
    )).filter(function(el){ return el.offsetParent !== null; });
  }
  var _lastFocus = null;
  function renderModal(){
    var root = ensureModal();
    var sticky = stickyBar();
    if (!state.open){
      root.innerHTML = '';
      document.documentElement.style.removeProperty('overflow');
      if (sticky) sticky.style.removeProperty('display'); // restore theme's sticky add-to-cart bar
      if (_lastFocus){ try { _lastFocus.focus(); } catch(e){} _lastFocus = null; } // restore focus to the trigger
      return;
    }
    document.documentElement.style.overflow = 'hidden';
    if (sticky) sticky.style.display = 'none'; // hide theme's sticky bar behind/over the modal
    var modal = root.querySelector('.dlf-modal');
    var justOpened = false;
    if (!modal){
      // Build the overlay + panel shell only once, so the open fade plays once —
      // NOT on every filter/sort re-render (that caused a flash on each click).
      root.innerHTML = '<div class="dlf-modal" data-action="close"><div class="dlf-modal__panel" role="dialog" aria-modal="true" aria-label="' + esc(SERVER ? L.backAll : PRODUCT_TITLE) + '" data-action="stop" tabindex="-1"></div></div>';
      modal = root.querySelector('.dlf-modal');
      _lastFocus = document.activeElement; // remember the trigger so focus can return on close
      justOpened = true;
    }
    var panel = modal.querySelector('.dlf-modal__panel');
    panel.className = 'dlf-modal__panel' + (state.detailId ? ' is-wide' : '');
    panel.innerHTML = panelBodyHTML();
    a11yControls(panel);
    size360(panel);
    attachInfiniteScroll(panel);
    applyHeadState(panel);
    if (justOpened){ try { panel.focus(); } catch(e){} } // move focus into the dialog on open only
  }
  /* loupe360 renders its canvas at the pixel size in the URL (it does NOT scale to the iframe),
   * so request a square matching the media's actual width — otherwise the spin shows at a
   * different size than the photo it replaces. Sized after render, once the media has a width. */
  function size360(panel){
    var f = panel && panel.querySelector('.dlf-360iframe');
    if (!f || f.getAttribute('src')) return;
    var media = f.parentNode;
    var w = media ? Math.round(media.getBoundingClientRect().width) : 0;
    if (!w) w = 340;
    var base = f.getAttribute('data-video') || '';
    // /{w}/{h} matches the media size; trailing /true is loupe360's autoplay flag (auto-rotate).
    f.src = base.replace(/(\/video\/)\d+\/\d+/, '$1' + w + '/' + w + '/true');
  }

  /* ---------- configurator-side integration ---------- */
  var _caratFs = null, _buyForm = null;
  function findCaratFieldset(){
    if (_caratFs && document.body.contains(_caratFs)) return _caratFs;
    var fs = document.querySelectorAll('variant-picker fieldset, .variant-picker fieldset, fieldset');
    // Match the carat option by legend text in either locale ("carat" / "quilat"[es] — covers
    // "Peso en quilates…"). Shopify translates the option name, so a plain 'carat' check misses in /es-mx.
    for (var i=0;i<fs.length;i++){ var t=(fs[i].textContent||'').toLowerCase(); if (t.indexOf('carat') >= 0 || t.indexOf('quilat') >= 0){ _caratFs = fs[i]; return _caratFs; } }
    return null;
  }
  function findBuyForm(){
    if (_buyForm && document.body.contains(_buyForm)) return _buyForm;
    _buyForm = document.querySelector('form[action*="/cart/add"]');
    return _buyForm;
  }

  function caratMount(){
    var carat = findCaratFieldset();
    if (!carat) return null;
    var m = document.getElementById('dlf-dp-carat');
    if (!m){ m = document.createElement('div'); m.id = 'dlf-dp-carat'; carat.parentNode.insertBefore(m, carat.nextSibling); }
    return m;
  }
  function engMount(){
    var form = findBuyForm();
    if (!form) return null;
    var m = document.getElementById('dlf-dp-eng');
    if (!m){ m = document.createElement('div'); m.id = 'dlf-dp-eng'; form.parentNode.insertBefore(m, form); }
    return m;
  }

  function engPreviewStyle(){
    if (state.engStyle === 'script') return 'font-family:var(--dlf-script);font-size:34px;line-height:1.15;color:var(--dlf-ink);';
    if (state.engStyle === 'serif') return 'font-family:var(--dlf-serif);font-style:italic;font-size:27px;letter-spacing:.5px;color:var(--dlf-ink);';
    return 'font-family:var(--dlf-mono);font-size:17px;letter-spacing:4px;text-transform:uppercase;color:var(--dlf-ink);';
  }
  function engStyleLabel(){ var s = ENG_STYLES.filter(function(x){return x.key===state.engStyle;})[0]; return s ? s.label : L.styleScript; }
  function hasEng(){ return !!(state.engText && state.engText.trim()); }

  function renderEng(){
    var m = engMount(); if (!m) return;
    var body = '';
    if (state.engOpen){
      var chips = ENG_STYLES.map(function(s){
        return '<div class="dlf-eng__chip' + (state.engStyle===s.key?' is-on':'') + '" data-dp="eng-style:' + s.key + '">' + esc(s.label) + '</div>';
      }).join('');
      body = '<div class="dlf-eng__body">' +
        '<div class="dlf-eng__styles">' + chips + '</div>' +
        '<div class="dlf-eng__inputwrap"><input id="dlf-eng-input" class="dlf-eng__input" maxlength="16" placeholder="' + esc(L.engPlaceholder) + '" value="' + esc(state.engText) + '"><span class="dlf-eng__count">' + (state.engText ? state.engText.length : 0) + '/16</span></div>' +
        '<div class="dlf-eng__preview"><span id="dlf-eng-preview" style="' + engPreviewStyle() + (hasEng()?'':'opacity:.34;') + '">' + (hasEng() ? esc(state.engText) : esc(L.yourEngraving)) + '</span></div>' +
        '<div class="dlf-eng__fine">' + esc(L.engFine) + '</div></div>';
    }
    m.innerHTML = '<div class="dlf-eng">' +
      '<div class="dlf-eng__head" data-dp="eng-toggle"><div class="dlf-eng__titles"><span class="dlf-eng__title">' + esc(L.addEngraving) + '</span><span class="dlf-eng__tag">' + esc(L.engTag) + '</span></div>' +
        '<span class="dlf-eng__toggle' + (state.engOpen?' is-open':'') + '">' + (state.engOpen ? '–' : '+') + '</span></div>' +
      body + '</div>';
    syncEngProps();
  }

  function syncEngProps(){
    var form = findBuyForm(); if (!form) return;
    function setInput(name, val){
      var el = form.querySelector('input[data-dp-prop="' + name + '"]');
      if (val == null){ if (el) el.remove(); return; }
      if (!el){ el = document.createElement('input'); el.type = 'hidden'; el.setAttribute('data-dp-prop', name); el.name = 'properties[' + name + ']'; form.appendChild(el); }
      el.value = val;
    }
    // Engraving properties apply on the generic (carat) path. When a specific stone is chosen the ATC is gated.
    if (hasEng() && !state.chosenId){ setInput('Engraving', state.engText.trim()); setInput('Engraving style', engStyleLabel()); }
    else { setInput('Engraving', null); setInput('Engraving style', null); }
  }

  function renderCarat(){
    var m = caratMount(); if (!m) return;
    var carat = findCaratFieldset();
    var chosen = state.chosenId ? diamondById(state.chosenId) : null;
    if (chosen){
      if (carat) carat.classList.add('dlf-hidden');
      m.innerHTML = '<div class="dlf-chosen">' +
        '<div class="dlf-chosen__head"><span>' + esc(L.yourDiamond) + '</span>' +
          '<span class="dlf-chosen__actions"><span class="dlf-link" data-dp="change">' + esc(L.changeDiamond) + '</span><span class="dlf-link dlf-link--muted" data-dp="remove">' + esc(L.remove) + '</span></span></div>' +
        '<div class="dlf-chosen__card">' +
          (chosen.img ? '<img class="dlf-chosen__thumb" src="' + esc(chosen.img) + '" alt="" loading="lazy">' : '<div class="dlf-chosen__thumb"></div>') +
          '<div class="dlf-chosen__body"><div class="dlf-chosen__title">' + esc(chosen.ct) + ' ct ' + esc(SHAPE) + '</div>' +
            '<div class="dlf-chosen__l2">' + esc([colorPhrase(chosen.color), chosen.clar, (chosen.cut ? cutPhrase(chosen.cut) : '')].filter(Boolean).join(' · ')) + '</div>' +
            '<div class="dlf-chosen__l3">' + esc(chosen.lab + ' · ' + chosen.cert + ' · ' + chosen.dims + ' mm') + '</div></div></div>' +
        '<div class="dlf-phase2note" style="display:none"></div>' +
      '</div>';
    } else {
      if (carat) carat.classList.remove('dlf-hidden');
      m.innerHTML = '<div class="dlf-hp-row">' + esc(L.preferOwn) + '&nbsp;&nbsp;<span class="dlf-hp-link" data-dp="open">' + esc(L.handpick) + '</span></div>';
    }
  }

  var _priceOrig = null;
  function topPriceEl(){
    var scope = document.querySelector('.price-mto-row') || document;
    var els = scope.querySelectorAll('product-price');
    for (var i = 0; i < els.length; i++){ if (!els[i].closest('.sticky-add-to-cart')) return els[i]; }
    // fallback: any non-sticky product price on the page
    els = document.querySelectorAll('product-price');
    for (var j = 0; j < els.length; j++){ if (!els[j].closest('.sticky-add-to-cart')) return els[j]; }
    return null;
  }
  function updateTopPrice(){
    var pe = topPriceEl(); if (!pe) return;
    var reg = pe.querySelector('.price__regular') || pe;
    var chosen = state.chosenId ? diamondById(state.chosenId) : null;
    var fee = deliveryFee();
    if (chosen || fee > 0){
      if (_priceOrig === null) _priceOrig = reg.textContent;
      var base = chosen ? (SETTING_BASE + chosen.price) : priceNum(_priceOrig);
      reg.textContent = fmt(base + fee) + ' USD';
    } else if (_priceOrig !== null){
      reg.textContent = _priceOrig; _priceOrig = null;
    }
  }
  // Item 9 — label the price as a total with zero new UI: reuse the existing italic "Made to order.
  // Ships by <date>." line. When a diamond is chosen it becomes "Total with your diamond · Made to
  // order, ships by <date>."; restored on remove. Same element, same typography.
  var _shipOrig = null;
  // Detect the italic "Made to order…" / "Hecho por encargo…" line in either language (robust even if
  // the theme's ship snippet and the picker locale ever disagree). Building strings stay locale-specific.
  var SHIP_RE = /made to order|hecho por encargo/i;
  function shipLineEl(){
    var els = document.querySelectorAll('em, span, p, div');
    for (var i = 0; i < els.length; i++){
      if (els[i].children.length === 0 && SHIP_RE.test(els[i].textContent)) return els[i];
    }
    return null;
  }
  // Width (px) the italic line's text would take on one line, in the real font.
  function measureItalic(text){
    var el = shipLineEl(); if (!el) return 0;
    var c = document.createElement('span');
    c.style.cssText = 'white-space:nowrap;position:absolute;visibility:hidden;left:-9999px;top:0;font-style:italic';
    c.style.fontSize = getComputedStyle(el).fontSize;
    c.textContent = text;
    document.body.appendChild(c);
    var w = c.getBoundingClientRect().width;
    c.remove();
    return w;
  }
  // Space available for the label = column width (a full-width sibling) minus room for the price + gap.
  function labelAvail(){
    var ref = document.querySelector('.variant-option__select-wrapper')
           || document.querySelector('form[action*="/cart/add"] button[name="add"]')
           || document.querySelector('.price-mto-row');
    return (ref ? ref.getBoundingClientRect().width : 9999) - 115;
  }
  function updateShipLine(){
    var el = shipLineEl(); if (!el) return;
    var express = state.delivery === 'express';
    if (state.chosenId || express){
      if (_shipOrig === null) _shipOrig = el.textContent;
      // tail = "Get it by <date>." — express recomputes the date; standard reuses the snippet's line.
      var tail = express ? (L.getItBy + shipDateStr(EXPRESS_WEEKS) + '.')
                         : _shipOrig.replace(/^\s*(?:made to order|hecho por encargo)\.\s*/i, '').trim();
      if (state.chosenId){
        var t = tail.charAt(0).toLowerCase() + tail.slice(1);
        var full = L.totalMTO + t;
        var mid = L.totalMid + tail;
        var brief = L.totalBrief;
        var avail = labelAvail();
        el.textContent = (measureItalic(full) <= avail) ? full
                       : (measureItalic(mid) <= avail) ? mid
                       : brief;
      } else {
        el.textContent = L.madeToOrder + tail;
      }
    } else if (_shipOrig !== null){
      el.textContent = _shipOrig; _shipOrig = null;
    }
  }
  // Keep the theme's sticky add-to-cart bar in sync with the chosen diamond (price + variant line).
  // The theme re-renders the bar on variant changes, so this re-runs from renderConfig each time.
  var _stickyPriceOrig = null, _stickyVarOrig = null;
  function stickyPriceReg(){ var s = stickyBar(); if (!s) return null; return s.querySelector('.sticky-add-to-cart__price .price__regular') || s.querySelector('.sticky-add-to-cart__price'); }
  function stickyVarEl(){ var s = stickyBar(); return s ? s.querySelector('.sticky-add-to-cart__variant') : null; }
  function updateStickyBar(){
    var reg = stickyPriceReg(), ve = stickyVarEl();
    var chosen = state.chosenId ? diamondById(state.chosenId) : null;
    var fee = deliveryFee();
    if (chosen || fee > 0){
      if (reg){ if (_stickyPriceOrig === null) _stickyPriceOrig = reg.textContent;
        var base = chosen ? (SETTING_BASE + chosen.price) : priceNum(_stickyPriceOrig);
        reg.textContent = fmt(base + fee) + ' USD'; }
      if (ve && chosen){ if (_stickyVarOrig === null) _stickyVarOrig = ve.textContent;
        var metal = readMetal() || (ve.textContent.split('/')[0] || '').trim();
        ve.textContent = ovDisp(metal) + ' · ' + chosen.ct + ' ct ' + (chosen.shape || SHAPE); }
    } else {
      if (reg && _stickyPriceOrig !== null){ reg.textContent = _stickyPriceOrig; _stickyPriceOrig = null; }
      if (ve && _stickyVarOrig !== null){ ve.textContent = _stickyVarOrig; _stickyVarOrig = null; }
    }
  }

  /* ---------- delivery: Standard vs Express make ---------- */
  function deliveryMount(){
    var form = findBuyForm(); if (!form) return null;
    var m = document.getElementById('dlf-dp-delivery');
    if (!m){
      m = document.createElement('div'); m.id = 'dlf-dp-delivery';
      var engM = document.getElementById('dlf-dp-eng');
      if (engM){ engM.parentNode.insertBefore(m, engM.nextSibling); } // below the engraving panel
      else { form.parentNode.insertBefore(m, form); }                // fallback: just above the buy form
    }
    return m;
  }
  // Express make as a single-row toggle (same row format as "Add an engraving" but it does NOT
  // expand — clicking adds/removes the +fee). Standard is the silent default ("Get it by <date>").
  // The tag shows the new (faster) date instead of "optional".
  function renderDelivery(){
    var m = deliveryMount(); if (!m) return;
    var on = state.delivery === 'express';
    m.innerHTML = '<div class="dlf-eng dlf-deliv2' + (on ? ' is-on' : '') + '">' +
      '<div class="dlf-eng__head" data-dp="deliv-express"><div class="dlf-eng__titles">' +
        '<span class="dlf-eng__title">' + esc(L.addExpress) + '</span>' +
        '<span class="dlf-eng__tag' + (on ? ' dlf-tag-on' : '') + '">' + esc(L.by) + esc(shipDateShort(EXPRESS_WEEKS)) + ' · +' + esc(feeStr()) + '</span>' +
      '</div><span class="dlf-eng__toggle' + (on ? ' is-on' : '') + '">' + (on ? '✓' : '+') + '</span></div>' +
    '</div>';
    syncDeliveryProp();
  }
  function syncDeliveryProp(){
    var form = findBuyForm(); if (!form) return;
    function setInput(name, val){
      var el = form.querySelector('input[data-dp-prop="' + name + '"]');
      if (val == null){ if (el) el.remove(); return; }
      if (!el){ el = document.createElement('input'); el.type = 'hidden'; el.setAttribute('data-dp-prop', name); el.name = 'properties[' + name + ']'; form.appendChild(el); }
      el.value = val;
    }
    // Generic (native) path only; the hand-pick bundle adds these in addBundleToCart.
    // "Delivery" is the visible line, "_dlf_express*" (underscore = hidden) drive the Cart Transform fee.
    if (state.delivery === 'express' && !state.chosenId){
      setInput('Delivery', L.expressCrafting + ' (+' + feeStr() + ')');
      if (EXPRESS_VARIANT){
        setInput('_dlf_express', 'gid://shopify/ProductVariant/' + EXPRESS_VARIANT);
        setInput('_dlf_express_price', Number(EXPRESS_FEE).toFixed(2));
      }
    } else {
      setInput('Delivery', null); setInput('_dlf_express', null); setInput('_dlf_express_price', null);
    }
  }

  /* ---------- ring size: "Help me later" (defer sizing, free kit ships with the ring) ---------- */
  function sizeControl(){ return document.querySelector('select[name="options[Ring size]"], select[name="options[Talla del anillo]"]'); }
  // With Help-me-later on, the shopper checks out without confirming size, so pick a sensible default
  // (closest to 7) so a variant still resolves; the real size is confirmed later via the free kit.
  function ensureDefaultSize(){
    var sel = sizeControl(); if (!sel || sel.value) return;
    var opts = [].slice.call(sel.options).filter(function(o){ return o.value; });
    if (!opts.length) return;
    var best = opts[0], bd = Infinity;
    opts.forEach(function(o){ var n = parseFloat(o.value); var d = isNaN(n) ? Infinity : Math.abs(n - 7); if (d < bd){ bd = d; best = o; } });
    sel.value = best.value; sel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  var SIZING_LATER = L.sizingLater;
  function syncSizeProp(){
    var form = findBuyForm(); if (!form) return;
    var el = form.querySelector('input[data-dp-prop="Sizing"]');
    // Generic (native variant) path only; the hand-pick bundle adds the prop in addBundleToCart.
    if (state.helpLater && !state.chosenId){
      if (!el){ el = document.createElement('input'); el.type = 'hidden'; el.setAttribute('data-dp-prop','Sizing'); el.name = 'properties[Sizing]'; form.appendChild(el); }
      el.value = SIZING_LATER;
    } else if (el){ el.remove(); }
  }
  // "Help me later" button to the RIGHT of the ring-size dropdown. The theme rebuilds the whole
  // .variant-option on every variant change, so we re-establish this on each render. We wrap the
  // dropdown + button in our own flex row (just those two, no wrapping) for reliable side-by-side.
  // The default product template (The Arco) has no "Not sure about your size?" text block like the
  // birthstone/letter templates carry, so the picker renders its own. It goes AFTER <variant-picker>
  // (outside variant-picker__form, which the theme wipes on every variant change) so it survives
  // re-renders; the class check keeps it idempotent.
  function renderSizeGuideLine(){
    if (document.querySelector('.dlf-sizeguide')) return;
    var links = document.querySelectorAll('a[href*="ring-size-guide"]');
    for (var i = 0; i < links.length; i++){
      if (!links[i].closest('.shopify-section-group-footer-group')) return; // template already has one
    }
    var sel = sizeControl(); if (!sel) return;
    var vp = sel.closest('variant-picker') || sel.closest('.variant-picker');
    if (!vp || !vp.parentNode) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var p = document.createElement('p');
    p.className = 'dlf-sizeguide';
    p.appendChild(document.createTextNode(L.sizeGuideQ + ' '));
    var a = document.createElement('a');
    a.href = root.replace(/\/$/, '') + '/pages/ring-size-guide';
    a.target = '_blank';
    a.textContent = L.sizeGuideLink;
    p.appendChild(a);
    vp.parentNode.insertBefore(p, vp.nextSibling);
  }
  function renderSizeHelp(){
    var sel = sizeControl(); if (!sel) return;
    var wrap = sel.closest('.variant-option__select-wrapper');
    if (!wrap) return;
    renderSizeGuideLine();
    // Overlay a plain text link on the dropdown's right end (absolute) — do NOT touch widths: the
    // size dropdown anchors this whole content-sized column, so shrinking/reparenting collapses it.
    wrap.classList.add('dlf-hml-host');
    var btn = wrap.querySelector('.dlf-hml-btn');
    if (!btn){ btn = document.createElement('button'); btn.type = 'button'; btn.className = 'dlf-hml-btn'; wrap.appendChild(btn); }
    btn.textContent = (state.helpLater ? '✓ ' : '') + L.helpLater;
    btn.classList.toggle('is-on', state.helpLater);
    wrap.classList.toggle('dlf-size-dim-on', state.helpLater);
    swapSizeGuide();
    syncSizeProp();
  }
  // When deferring, replace the theme's "Not sure about your size? Get a free sizing kit →" line
  // with the kit-ships reassurance; restore the original when toggled off.
  var SIZING_NOTE = L.sizingNote;
  function swapSizeGuide(){
    var swapped = document.querySelector('.dlf-sizeguide-swapped');
    // Never target the footer's Ring Size Guide menu link — only the product-area legend.
    var a = null, links = document.querySelectorAll('a[href*="ring-size-guide"]');
    for (var i = 0; i < links.length; i++){
      if (!links[i].closest('.shopify-section-group-footer-group')){ a = links[i]; break; }
    }
    var line = swapped || (a ? (a.closest('p') || a.parentElement) : null);
    if (!line) return;
    if (state.helpLater){
      if (!line.classList.contains('dlf-sizeguide-swapped')){
        line.setAttribute('data-dlf-orig', line.innerHTML);
        line.classList.add('dlf-sizeguide-swapped');
      }
      if (line.textContent.trim() !== SIZING_NOTE) line.textContent = SIZING_NOTE;
    } else if (line.classList.contains('dlf-sizeguide-swapped')){
      var orig = line.getAttribute('data-dlf-orig');
      if (orig != null) line.innerHTML = orig;
      line.classList.remove('dlf-sizeguide-swapped');
      line.removeAttribute('data-dlf-orig');
    }
  }
  function renderConfig(){ renderCarat(); renderEng(); renderDelivery(); renderSizeHelp(); gateAtc(); updateTopPrice(); updateShipLine(); updateStickyBar(); notifyConfig(); }

  /* ---------- events ---------- */
  function toggleFilter(key, val){
    var cur = state.filterSel[key] || [];
    state.filterSel[key] = cur.indexOf(val) >= 0 ? cur.filter(function(x){ return x !== val; }) : cur.concat([val]);
    if (SERVER) reloadServerDebounced();
    renderModal();
  }
  function handleAction(action){
    var parts = action.split(':'), cmd = parts[0];
    if (cmd === 'stop') return;
    if (cmd === 'close'){ state.open = false; state.detailId = null; state.openFilter = null; renderModal(); return; }
    if (cmd === 'closefilters'){ state.openFilter = null; renderModal(); return; }
    if (cmd === 'chip'){ state.openFilter = state.openFilter === parts[1] ? null : parts[1]; renderModal(); return; }
    if (cmd === 'opt'){ toggleFilter(parts[1], parts.slice(2).join(':')); return; }
    if (cmd === 'clear'){ state.filterSel = { Carat:[], Color:[], Cut:[], Lab:[], Clarity:[] }; state.openFilter = null; if (SERVER) reloadServer(); else renderModal(); return; }
    if (cmd === 'sort'){ state.sort = state.sort === 'asc' ? 'desc' : 'asc'; if (SERVER) reloadServer(); else renderModal(); return; }
    if (cmd === 'loadmore'){ loadMoreServer(); return; }
    if (cmd === 'retry'){ reloadServer(); return; }
    if (cmd === 'open'){ state.detailId = parseInt(parts[1], 10); state.show360 = AUTO_360; state.headHidden = false; state.openFilter = null; renderModal(); return; }
    if (cmd === 'back'){ state.detailId = null; state.show360 = false; state.headHidden = false; renderModal(); return; }
    if (cmd === 'play360'){ state.show360 = true; renderModal(); return; }
    if (cmd === 'hide360'){ state.show360 = false; renderModal(); return; }
    if (cmd === 'choose'){ state.chosenId = parseInt(parts[1], 10); state.open = false; state.detailId = null; renderModal(); renderConfig(); return; }
  }

  document.addEventListener('click', function(e){
    if (e.target.closest('a[href]')) return; // let real links (e.g. certificate PDF) work
    var _root = document.getElementById(ROOT_ID);
    // Any click outside an open filter chip/popover closes the popover.
    if (state.openFilter && _root && _root.contains(e.target) && !e.target.closest('.dlf-chipwrap')){
      state.openFilter = null; renderModal(); e.preventDefault(); return;
    }
    var actionEl = e.target.closest('[data-action]');
    var root = document.getElementById(ROOT_ID);
    if (actionEl && root && root.contains(actionEl)){ e.preventDefault(); handleAction(actionEl.getAttribute('data-action')); return; }
    var dp = e.target.closest('[data-dp]');
    if (dp){
      e.preventDefault();
      var a = dp.getAttribute('data-dp');
      if (a === 'open' || a === 'change'){ state.open = true; state.detailId = null; renderModal(); if (SERVER && !state.srvLoaded && !state.srvLoading) reloadServer(); }
      else if (a === 'remove'){ state.chosenId = null; renderConfig(); }
      else if (a === 'bd-toggle'){ state.bdOpen = !state.bdOpen; renderCarat(); }
      else if (a === 'deliv-express'){ state.delivery = (state.delivery === 'express') ? 'standard' : 'express'; renderDelivery(); updateTopPrice(); updateShipLine(); updateStickyBar(); notifyConfig(); }
      else if (a === 'eng-toggle'){ state.engOpen = !state.engOpen; renderEng(); }
      else if (a.indexOf('eng-style:') === 0){ state.engStyle = a.split(':')[1]; renderEng(); }
      return;
    }
  }, false);

  document.addEventListener('input', function(e){
    if (e.target && e.target.id === 'dlf-eng-input'){
      state.engText = e.target.value;
      var prev = document.getElementById('dlf-eng-preview');
      if (prev){ prev.textContent = hasEng() ? state.engText : L.yourEngraving; prev.setAttribute('style', engPreviewStyle() + (hasEng()?'':'opacity:.34;')); }
      var cnt = e.target.parentNode.querySelector('.dlf-eng__count');
      if (cnt) cnt.textContent = (state.engText ? state.engText.length : 0) + '/16';
      syncEngProps();
    }
  }, false);

  // "Help me later" button (rendered beside the ring-size dropdown). Capture + stopPropagation so the
  // theme doesn't treat the click as a variant interaction and re-render the picker mid-toggle.
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.dlf-hml-btn');
    if (b){
      e.preventDefault(); e.stopPropagation();
      state.helpLater = !state.helpLater;
      if (state.helpLater) ensureDefaultSize();
      renderSizeHelp();
    }
  }, true);

  document.addEventListener('keydown', function(e){
    if (!state.open) return;
    var root = document.getElementById(ROOT_ID);
    var panel = root && root.querySelector('.dlf-modal__panel');
    if (e.key === 'Escape'){
      // Close the filter popover first if one is open; otherwise close the whole modal.
      if (state.openFilter){ state.openFilter = null; renderModal(); }
      else { state.open = false; state.detailId = null; renderModal(); }
      return;
    }
    // Enter/Space activates a focused div-based control (they carry role="button").
    if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar')){
      var actionEl = e.target.closest && e.target.closest('[data-action]');
      if (actionEl && panel && panel.contains(actionEl) && (actionEl.getAttribute('data-action')||'').split(':')[0] !== 'stop'){
        e.preventDefault(); handleAction(actionEl.getAttribute('data-action')); return;
      }
    }
    // Focus trap: keep Tab within the dialog while it's open.
    if (e.key === 'Tab' && panel){
      var f = focusablesIn(panel);
      if (!f.length){ e.preventDefault(); panel.focus(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || a === panel)){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last){ e.preventDefault(); first.focus(); }
      else if (!panel.contains(a)){ e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- add-to-cart: hand-pick adds the ring + diamond bundle ---------- */
  function gateAtc(){
    var form = findBuyForm();
    var btn = form && form.querySelector('button[type="submit"]');
    if (btn) btn.removeAttribute('data-dp-blocked');
  }
  function settingPriceStr(){ return Number(SETTING_BASE).toFixed(2); }
  function flashNote(msg){
    var note = document.querySelector('#dlf-dp-carat .dlf-phase2note');
    if (note){ note.textContent = msg || L.cartErr; note.style.display = ''; note.classList.add('is-flash'); setTimeout(function(){ note.classList.remove('is-flash'); note.style.display = 'none'; }, 2400); }
  }
  // Read the currently-selected metal + ring size straight from the theme's variant picker
  // (fieldsets live outside the buy form). Returns "Metal||Size" or null.
  // Match a variant option's fieldset by its legend, tolerant of Shopify's /es-mx translation of the
  // option NAME. "Color" is identical in ES; "Ring size" becomes "Talla del anillo" → also accept "talla".
  function optFieldset(label){
    var subs = [label.toLowerCase()];
    if (label.toLowerCase() === 'ring size') subs.push('talla');
    var fss = document.querySelectorAll('fieldset');
    for (var i = 0; i < fss.length; i++){
      var l = fss[i].querySelector('legend');
      if (!l) continue;
      var t = l.textContent.trim().toLowerCase();
      for (var j = 0; j < subs.length; j++){ if (t.indexOf(subs[j]) === 0) return fss[i]; }
    }
    return null;
  }
  function selMetalSizeKey(){
    var metalFs = optFieldset('Color');
    var metalR = metalFs && metalFs.querySelector('input[type="radio"]:checked');
    var metal = metalR ? metalR.value : null;
    var sizeSel = document.querySelector('select[name="options[Ring size]"], select[name="options[Talla del anillo]"]');
    var size = sizeSel ? sizeSel.value : null;
    if (!size){
      var sizeFs = optFieldset('Ring size');
      var sizeR = sizeFs && sizeFs.querySelector('input[type="radio"]:checked');
      size = sizeR ? sizeR.value : null;
    }
    return (metal && size) ? (metal + '||' + size) : null;
  }
  function addBundleToCart(form, chosen){
    var idInput = form.querySelector('[name="id"]');
    var ringVariantId = idInput && idInput.value;
    if (!ringVariantId){ flashNote(L.pickSize); return; }
    if (!chosen || !chosen.variantId){ flashNote(L.stoneSoon); return; }
    var diamondDesc = chosen.ct + ' ct ' + (chosen.shape || SHAPE) + ' · ' + chosen.color + '/' + chosen.clar;
    if (chosen.cut && String(chosen.cut).trim()) diamondDesc += ' · ' + String(chosen.cut).trim();
    // La piedra va como SU PROPIA linea (precio de catalogo cobrado por Shopify); anillo y piedra se ligan con _dlf_pair
    // y la validacion del checkout exige que viajen juntos.
    var pair = 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var props = {
      '_dlf_pair': pair,
      'Diamond': diamondDesc,
      'Certificate': chosen.lab + ' ' + chosen.cert
    };
    if (hasEng()){ props['Engraving'] = state.engText.trim(); props['Engraving style'] = engStyleLabel(); }
    if (state.helpLater){ props['Sizing'] = SIZING_LATER; }
    if (state.delivery === 'express'){
      props['Delivery'] = L.expressCrafting + ' (+' + feeStr() + ')';
      if (EXPRESS_VARIANT){ props['_dlf_express'] = 'gid://shopify/ProductVariant/' + EXPRESS_VARIANT; props['_dlf_express_price'] = Number(EXPRESS_FEE).toFixed(2); }
    }
    // Add the "Hand-picked" carat variant as the bundle line so the checkout header reads
    // "…/ Hand-picked / 6" instead of the misleading "1ct". And resolve the hidden "setting-only"
    // variant (Metal × Size, no carat) for the Cart Transform's band component. Both keyed by metal+size,
    // read from the live variant picker (robust vs Liquid's 250-variant cap). Fall back to the selected
    // ring variant if the maps are unavailable.
    // Primary: map the resolved ring variant id -> "metal||size" (authoritative, covers all 408
    // variants beyond Liquid's 250 cap). Fallback: read the picker controls.
    var mkey = (CFG.ringSizeIndex || {})[String(ringVariantId)] || selMetalSizeKey();
    var lineId = (mkey && (CFG.handpickVariants || {})[mkey]) || ringVariantId;
    var setVarId = mkey && (CFG.settingVariants || {})[mkey];
    var body = { items: [{ id: Number(lineId), quantity: 1, properties: props },
      { id: Number(chosen.variantId), quantity: 1, properties: { '_dlf_pair': pair, 'Certificate': chosen.lab + ' ' + chosen.cert } }] };
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(j){ return { ok:r.ok, j:j }; }); })
      .then(function(res){
        if (!res.ok){ _bundleBusy = false; flashNote((res.j && res.j.description) || L.cartErr); return; }
        window.location.href = '/cart'; // success navigates away; keep the lock so a slow nav can't double-add
      })
      .catch(function(){ _bundleBusy = false; flashNote(L.netErr); });
  }
  // When a diamond is hand-picked, WE own the add-to-cart (the bundle). Intercept the click on the
  // ATC button (and the form submit) in the capture phase and stopImmediatePropagation so the theme's
  // own add-to-cart never fires — otherwise the plain ring is added too (double product bug).
  var _bundleBusy = false;
  function interceptAtc(e){
    if (!state.chosenId) return;
    var form = null;
    if (e.type === 'submit'){
      form = (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) ? e.target : null;
    } else { // click
      var btn = e.target.closest && e.target.closest('.add-to-cart-button, button[name="add"], button[type="submit"], [type="submit"]');
      if (!btn) return;
      // Only our two add-to-cart buttons: the one in the buy form and the sticky bar's (which is a
      // type="button" outside any form, so resolve to the main form). Ignore any other add buttons.
      var inSticky = btn.closest('sticky-add-to-cart, .sticky-add-to-cart');
      form = btn.closest('form[action*="/cart/add"]') || (inSticky ? findBuyForm() : null);
    }
    if (!form) return;
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();
    // No-preselect gate: don't add the bundle while metal/size are still unchosen.
    if (window.DLF_NPS && !window.DLF_NPS.ready()) { window.DLF_NPS.nudge(); return; }
    if (_bundleBusy) return;
    _bundleBusy = true;
    // The lock is released the moment /cart/add.js returns an error (see addBundleToCart); success
    // navigates away. This long timer is only a safety net if the request never settles at all.
    setTimeout(function(){ _bundleBusy = false; }, 15000);
    addBundleToCart(form, diamondById(state.chosenId));
  }
  document.addEventListener('click', interceptAtc, true);
  document.addEventListener('submit', interceptAtc, true);
  // Re-evaluate the total label's tail when the viewport width changes.
  var _shipRz;
  window.addEventListener('resize', function(){ clearTimeout(_shipRz); _shipRz = setTimeout(function(){ if (state.chosenId) updateShipLine(); }, 120); });

  /* ---------- hint / shareable configuration ---------- */
  // The "Send it as a hint" band (sections/dlf-hint.liquid) reads the live configuration through
  // window.DLF_CONFIG and builds a shareable link. Opening that link restores the exact ring here.
  function b64urlEncode(str){ var b = btoa(unescape(encodeURIComponent(str))); return b.replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,''); }
  function b64urlDecode(s){ s = s.replace(/-/g,'+').replace(/_/g,'/'); while (s.length % 4) s += '='; return decodeURIComponent(escape(atob(s))); }
  function readMetal(){ var fs = optFieldset('Color'); var r = fs && fs.querySelector('input[type="radio"]:checked'); return r ? r.value : null; }
  function readSize(){ var sel = document.querySelector('select[name="options[Ring size]"], select[name="options[Talla del anillo]"]'); if (sel && sel.value) return sel.value; var fs = optFieldset('Ring size'); var r = fs && fs.querySelector('input[type="radio"]:checked'); return r ? r.value : null; }
  function readCarat(){ var fs = findCaratFieldset(); var r = fs && fs.querySelector('input[type="radio"]:checked'); return r ? r.value : null; }
  function currentConfig(){
    var chosen = state.chosenId ? diamondById(state.chosenId) : null;
    var metal = readMetal(), size = readSize(), carat = readCarat();
    var diamondLabel = chosen ? (chosen.ct + ' ct ' + (chosen.shape || SHAPE) + ' · ' + chosen.color + '/' + chosen.clar)
                              : (carat ? (carat + L.centerSuffix) : null);
    var express = state.delivery === 'express';
    var bits = []; if (metal) bits.push(ovDisp(metal)); if (diamondLabel) bits.push(diamondLabel); if (express) bits.push(L.expressCrafting);
    var total = chosen ? (SETTING_BASE + chosen.price + deliveryFee()) : null;
    return {
      productTitle: PRODUCT_TITLE, settingLabel: SETTING_LABEL, productHandle: CFG.productHandle,
      metal: metal, size: size, carat: carat, diamond: chosen || null, express: express,
      engraving: hasEng() ? { text: state.engText.trim(), style: engStyleLabel() } : null,
      summary: bits.join(' · '), total: total, totalStr: total != null ? fmt(total) : null,
      cert: chosen ? (chosen.lab + ' ' + chosen.cert) : null,
      hasChosen: !!chosen, shareUrl: buildHintUrl()
    };
  }
  function buildHintUrl(){
    var chosen = state.chosenId ? diamondById(state.chosenId) : null;
    var p = {}; var metal = readMetal(), size = readSize(), carat = readCarat();
    if (metal) p.m = metal; if (size) p.s = size; if (carat) p.c = carat;
    if (hasEng()) p.e = { t: state.engText.trim(), y: state.engStyle };
    if (state.delivery === 'express') p.x = 1;
    if (chosen) p.d = { id: chosen.id, variantId: chosen.variantId, ct: chosen.ct, color: chosen.color,
      clar: chosen.clar, cut: chosen.cut, lab: chosen.lab, shape: chosen.shape, cert: chosen.cert,
      dims: chosen.dims, price: chosen.price, img: chosen.img, video: chosen.video, certPdf: chosen.certPdf,
      handle: chosen.handle, polish: chosen.polish, sym: chosen.sym };
    var handle = CFG.productHandle || (location.pathname.split('/products/')[1] || '').split('?')[0] || '';
    var base;
    if (handle){
      // Keep the market/language prefix (/es-mx, /es, …) so the recipient lands in the
      // sharer's language and currency, not the default-English store.
      var prefix = location.pathname.indexOf('/products/') > -1 ? location.pathname.split('/products/')[0] : '';
      base = location.origin + prefix + '/products/' + handle;
    } else {
      base = location.origin + location.pathname;
    }
    return base + '?dlf_hint=' + b64urlEncode(JSON.stringify(p));
  }
  function notifyConfig(){ try { document.dispatchEvent(new CustomEvent('dlf:config', { detail: currentConfig() })); } catch (e){} }
  window.DLF_CONFIG = { get: currentConfig, buildHintUrl: buildHintUrl };

  /* ---------- restore a shared configuration from ?dlf_hint= ---------- */
  function fireRadio(input){ input.checked = true; input.dispatchEvent(new Event('input', { bubbles: true })); input.dispatchEvent(new Event('change', { bubbles: true })); }
  function setFieldsetRadio(which, value){
    var fs = which === 'carat' ? findCaratFieldset() : optFieldset(which);
    if (!fs) return; var rs = fs.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < rs.length; i++){ if (rs[i].value === value){ if (!rs[i].checked) fireRadio(rs[i]); return; } }
  }
  function setSize(value){
    var sel = document.querySelector('select[name="options[Ring size]"], select[name="options[Talla del anillo]"]');
    if (sel){ sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
    setFieldsetRadio('Ring size', value);
  }
  var _restored = false;
  function restoreFromUrl(){
    if (_restored) return; _restored = true;
    var m = location.search.match(/[?&]dlf_hint=([^&#]+)/); if (!m) return;
    var payload; try { payload = JSON.parse(b64urlDecode(decodeURIComponent(m[1]))); } catch (e){ return; }
    if (!payload) return;
    if (payload.d && payload.d.id != null){
      // The payload is attacker-controllable (anyone can craft a ?dlf_hint link). Sanitize every
      // URL field before it reaches the DOM so a javascript:/data: URL can't execute in the
      // recipient's session; the checkout price is server-authoritative (Cart Transform ignores
      // client-sent prices), so forged specs/price here are cosmetic only.
      payload.d.img = safeUrl(payload.d.img);
      payload.d.video = safeUrl(payload.d.video);
      payload.d.certPdf = safeUrl(payload.d.certPdf);
      LOADED[payload.d.id] = payload.d; state.chosenId = payload.d.id;
    }
    if (payload.e && payload.e.t){ state.engText = payload.e.t; if (/serif/i.test(payload.e.y)) state.engStyle = 'serif'; else if (/block/i.test(payload.e.y)) state.engStyle = 'block'; else state.engStyle = 'script'; state.engOpen = true; }
    if (payload.x) state.delivery = 'express';
    if (payload.m) setFieldsetRadio('Color', payload.m);
    if (payload.c && !payload.d) setFieldsetRadio('carat', payload.c);
    if (payload.s) setSize(payload.s);
  }

  /* In an international market (server mode + @inContext), the diamond prices come back in the
   * market currency, so the setting base and express fee (both USD config numbers) must be fetched
   * in that same currency — otherwise the roll-up would sum MXN + USD and mislabel it. On success
   * we flip CUR so fmt() renders the market currency; on failure we keep the USD fallback. */
  function applyMarketPricing(){
    if (!SERVER || !(window.DLF_DIAMOND_API && DLF_DIAMOND_API.country)) return;
    var map = CFG.settingVariants || {};
    var firstId = null;
    for (var k in map){ if (Object.prototype.hasOwnProperty.call(map, k)){ firstId = map[k]; break; } }
    if (!firstId) return;
    DLF_DIAMOND_API.variantPrice(firstId).then(function(p){
      if (!p || !p.amount) return;
      SETTING_BASE = p.amount; CUR = p.currency;
      if (EXPRESS_VARIANT){
        DLF_DIAMOND_API.variantPrice(EXPRESS_VARIANT).then(function(x){
          if (x && x.amount != null) EXPRESS_FEE = x.amount;
        }).catch(function(){}).then(function(){ renderConfig(); if (state.open) renderModal(); });
      } else {
        renderConfig(); if (state.open) renderModal();
      }
    }).catch(function(){});
  }

  /* ---------- boot ---------- */
  function boot(){
    ensureModal();
    applyMarketPricing();
    function tryInit(){
      if (findCaratFieldset() && findBuyForm()){ restoreFromUrl(); renderConfig(); return true; }
      return false;
    }
    // Try synchronously first: the script loads after the variant/buy markup, so on a normal
    // parse the config UI exists before the first paint (no flash). The interval is a fallback.
    if (!tryInit()){
      var tries = 0;
      var t = setInterval(function(){
        if (tryInit() || ++tries > 50) clearInterval(t);
      }, 200);
    }
    document.addEventListener('variant:update', function(){ setTimeout(renderConfig, 40); });
  }
  boot();
})();
